export { default } from "./src/variant";
// export type { UniformVariantProps } from "./src/variant";
